<h4 class="title">Merge Employee</h4>
<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">

      <div class="col-md-12">
        <h5 class="form-lable">Company Name</h5>
        <p-dropdown [options]="Company_details" [(ngModel)]="company_name"
            placeholder="Company Type" optionLabel="y" [showClear]="true"></p-dropdown>
     </div>


     <div class="col-md-6">
      <h5 class="form-lable">Report to Designations</h5>
      <p-dropdown [options]="Designation_details1" (onChange)="fetchuser_1()" [(ngModel)]="report_to_design"
          placeholder="Report to Designations" optionLabel="y" [showClear]="true"></p-dropdown>
     </div>


     <div class="col-md-6">
      <h5 class="form-lable">Report to User Details</h5>
      <p-dropdown [options]="User_details1" (onChange)="Report_fetch()" [(ngModel)]="report_to"
          placeholder="Report to User Details" optionLabel="y" [showClear]="true"></p-dropdown>
     </div>



     <div class="col-md-6">
      <h5 class="form-lable">Reporter to Designations</h5>
      <p-dropdown [options]="Designation_details2" (onChange)="fetchuser_2()" [(ngModel)]="user_to_design"
          placeholder="Reporter to Designations" optionLabel="x" [showClear]="true"></p-dropdown>
     </div>


     <div class="col-md-6">
      <h5 class="form-lable">Reporter to User Details</h5>
      <p-dropdown [options]="User_details2" (onChange)="Reporter_fetch()" [(ngModel)]="user"
          placeholder="Reporter to User Details" optionLabel="y" [showClear]="true"></p-dropdown>
     </div>

     <div class="col-md-12" style="margin-top: 15px;">
      <button  type="button" class="btn btn-primary" (click)="merge()">Merge</button>
     </div>

    </div>
</div>




<div class="row">
    <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div>
    <!-- <div class="col-md-8 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="doc_form()">Add</button>
    </div> -->
</div>
<div class="doc-table">

    <div class="card-box"> <p-table [value]="Merge_details | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

        <ng-template pTemplate="header">
            <tr class="thhead">
                <th class="th-1">S.No</th>
                <th>Bank Name</th>
                <th>Reporting to</th>
                <th>Report by </th>
                <th>Status</th>
                <th>Create by</th>
                <th>Create at</th>
                <th style="width: 110px;text-align:center">
                    Action
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr class="tdrow">
                <td>{{i+1}}</td>
            <td>{{item.company_name}}</td>
            <td><p>{{item.report_to_id.name}}</p><p>-({{item.report_to_id.designation}})</p></td>
            <td><p>{{item.user_id.name}}</p><p>-({{item.user_id.designation}})</p></td>
            <td>{{item.status}}</td>
            <td>{{item.created_by}}</td>
            <td>{{item.createdAt | date}}</td>
            <td class="act">
              <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete" (click)="delete(item._id)"></i>
                <!-- <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit" (click)="show_edit(item)" *ngIf="item.designation !==	'Super Admin'"></i>
                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete" (click)="delete(item._id)" *ngIf="item.designation !==	'Super Admin'"></i> -->
            </td>
            </tr>
        </ng-template>
     </p-table>  </div>

</div>
